import { render } from "./LastPageAttorney.vue?vue&type=template&id=e15bb0f2"
import script from "./LastPageAttorney.vue?vue&type=script&lang=js"
export * from "./LastPageAttorney.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__